/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  if(typeof ajaxCart != "undefined") {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  }
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};
timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $addToCartBundle = $('#AddToCartBundle'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');
  	  $discountPercentage = $('#ProductPrice').attr("data-discount");

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0],
          pattern = /[?&]v=([^&#]*)/,
          v = pattern.exec(newImg.src)[1];
          var imgZoom = newImg.src;
      	  $('.magnify-lens').css('background', 'url(' + imgZoom + ')');  

      //console.log(`newImg`, newImg);
      
      //Shopify.Image.switchImage(newImg, el, timber.switchImage);      
    }

    // Select a valid variant if available
    if (variant.available) {
      
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartBundle.removeClass('disabled').prop('disabled', false);
      
      if (typeof searchCustomerTags != 'undefined' && searchCustomerTags.indexOf('tradeprogram') !== -1) {
        $addToCartText.html('Add to Quote'); 
        $('#cartBtn').html('Add to Quote');
      } else {      
        $addToCartText.html("Add to Project"); 
        $('#cartBtn').html("Add to Project");
        $('#AddToCartSample').html("Add to Project");
      }
      
//      $addToCartText.html($addToCart.text()); 
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartBundle.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Contact Us");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    if($discountPercentage > 0) {
    	//var discountPrice = Math.round((variant.price - (variant.price * $discountPercentage))/100) * 100;
        var discountPrice = ((variant.price - (variant.price * $discountPercentage))/100)*100;
      	$productPrice.html( Shopify.formatMoney(discountPrice, moneyFormat) );
    	$('#ComparePriceTest').html('<s>' + Shopify.formatMoney(variant.price, moneyFormat) + '</s>');
	      
    } else {
    	$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );  
    }

    $('#ProductPriceBold').html( Shopify.formatMoney(variant.price, moneyFormat) );  
    
    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        //.html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .html('<s>' + Shopify.formatMoney(variant.compare_at_price, moneyFormat)+'</s>')
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartBundle.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      var newImageAlt = $(this).find('img').attr('alt');
      timber.switchImage(newImage, { alt: newImageAlt }, timber.cache.$productImage);
      var newZoom = $(this).find('img').attr('data-magnify-src');
      $('.magnify-lens').css('background', 'url(' + newZoom + ')');  
      timber.switchImage(newImage, { dataMagnifySrc: newZoom }, timber.cache.$productImage);
      
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  $el.attr('alt', imgObject.alt);
  $el.attr('data-magnify-src', imgObject.dataMagnifySrc);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);







/*!
 * Lazy Load - JavaScript plugin for lazy loading images
 *
 * Copyright (c) 2007-2017 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   https://appelsiini.net/projects/lazyload
 *
 * Version: 2.0.0-beta.2
 *
 */

(function (root, factory) {
    if (typeof exports === "object") {
        module.exports = factory(root);
    } else if (typeof define === "function" && define.amd) {
        define([], factory(root));
    } else {
        root.LazyLoad = factory(root);
    }
}) (typeof global !== "undefined" ? global : this.window || this.global, function (root) {

    "use strict";

    var defaults = {
        src: "data-src",
      	src2: "data-src2",
        srcset: "data-srcset",
        selector: ".lazyload",
		afterLoad: function(){},
		applySrc: true,
        width: 300,
        height: 300,
      	placeholderBg: '#f8f8f8',
      	errorBg: '#efefef',
      	watermark: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjM2Rjc5QzE1OTI1NzExRTk4N0JDQ0Q3NDU4MUNDMDZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjM2Rjc5QzE2OTI1NzExRTk4N0JDQ0Q3NDU4MUNDMDZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzZGNzlDMTM5MjU3MTFFOTg3QkNDRDc0NTgxQ0MwNkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzZGNzlDMTQ5MjU3MTFFOTg3QkNDRDc0NTgxQ0MwNkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5wUNfvAAAApklEQVR42uyXzwqAIAyHW/SGPktdvHqyV9FntHUQpDL/TBjRBh7kh/Njzk0hhDBx2jwxmwAsb6L3vjdBNqXUzhkBi/Ca+wgMQhjuHNAIYbmTcJVrKABkACwqQNFJANF5bpNaPWfQ2o7T8vzkvKTf7ARoHc65QNHTAZ94kJS6IqFrlgGi89wmtXoXwHUxdT6kEFEjMqQSjswJ6QUCwA4A8jf8PcAhwAAa1L+7bexhVgAAAABJRU5ErkJggg==',
      	watermarkPercent: 90
    };

    /**
    * Merge two or more objects. Returns a new object.
    * @private
    * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
    * @param {Object}   objects  The objects to merge together
    * @returns {Object}          Merged values of defaults and options
    */
    var extend = function ()  {

        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;

        /* Check if a deep merge */
        if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
            deep = arguments[0];
            i++;
        }

        /* Merge the object into the extended object */
        var merge = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    /* If deep merge and property is an object, merge properties */
                    if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                        extended[prop] = extend(true, extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        /* Loop through each object and conduct a merge */
        for (; i < length; i++) {
            var obj = arguments[i];
            merge(obj);
        }

        return extended;
    };

    function LazyLoad(images, options) {
        this.settings = extend(defaults, options || {});
        this.images = images || document.querySelectorAll(this.settings.selector);
        this.observer = null;
      	this.windowLoad = false;
        this.init();
    }

    LazyLoad.prototype = {
        init: function() {

            /* Without observers load everything and bail out early. */
            if (!root.IntersectionObserver) {
                this.loadImages();
                return;
            }

            var self = this;
            var observerConfig = {
                root: null,
                rootMargin: "0px",
                threshold: [0]
            };
			
			

            this.observer = new IntersectionObserver(function(entries) {
                entries.forEach(function (entry) {
                    if (entry.intersectionRatio > 0) {
                        self.observer.unobserve(entry.target);
                        var src = entry.target.getAttribute(self.settings.src);
                        var srcset = entry.target.getAttribute(self.settings.srcset);
                        if ("img" === entry.target.tagName.toLowerCase() && self.settings.applySrc) {
                            if (src) {
                                entry.target.src = src;
                            }
                            if (srcset) {
                                entry.target.srcset = srcset;
                            }
                        } else if(self.settings.applySrc) {
                            entry.target.style.backgroundImage = "url(" + src + ")";
                        }
						
						if(self.settings.afterLoad) {
							self.settings.afterLoad(entry.target, src, srcset);
						}
                    }
                });
            }, observerConfig);
          
          
            this.imageLoop(this.images, 0, 100, 300, function(image){
				self.observer.observe(image);
              
              	if(self.settings.applySrc) {
					self.createImgSrc(image);
				}
              
                image.onerror = function(){
                  //console.log(this);
                  self.onError(this);
                };

              
              
            });
            
        },
      
      	onError: function(ele) {
          	var src2 = $(ele).attr(this.settings.src2);
          	src2 = src2 ? src2.trim() : "";
          
            if(src2.length) {
              ele.src = src2;
            } else {
              this.getBase64Image(ele, this.settings.width, this.settings.height, this.settings.errorBg, this.settings.watermark);
            }
        },
		
      	imageLoop: function (object, start, loop, delay, callback) {
          var _this = this;
          
          loop = (start + loop) - 1;
          
          for(var n = start; n<object.length; n++) {
            callback(object[n]);
            //console.log(n);
            
            if(loop == n && object[n+1]) {
              if(_this.windowLoad === false) {
                window.addEventListener("load", function(){
                  	setTimeout(function(){
                      _this.windowLoad = true;
                      _this.imageLoop(object, n+1, loop, delay, callback);
                    }, delay);
                });
                
              } else {
                setTimeout(function(){
					_this.imageLoop(object, n+1, loop, delay, callback);
                }, delay);
                
              }
              
              break;
              
            }
          }
          	
        },

        loadAndDestroy: function () {
            if (!this.settings) { return; }
            this.loadImages();
            this.destroy();
        },

        loadImages: function () {
            if (!this.settings) { return; }

            var self = this;
            this.images.forEach(function (image) {
                var src = image.getAttribute(self.settings.src);
                var srcset = image.getAttribute(self.settings.srcset);
                if ("img" === image.tagName.toLowerCase() && self.settings.applySrc) {
                    if (src) {
                        image.src = src;
                      
                    } if (srcset) {
                        image.srcset = srcset;
                      
                    }
                } else if(self.settings.applySrc) {
                    image.style.backgroundImage = "url('" + src + "')";
                }
				
				if(self.settings.afterLoad) {
					self.settings.afterLoad(image, src, srcset);
				}
            });
        },

        destroy: function () {
            if (!this.settings) { return; }
            this.observer.disconnect();
            this.settings = null;
        },
		createImgSrc: function(image){
			var width = image.getAttribute('width'),
				height = image.getAttribute('height'),
                src = image.src;
          
            width = width && width.length ? parseInt(width) : 0;
            height = height && height.length ? parseInt(height) : 0;
          
            if(width !== 0 && height !== 0) {
				this.settings.width = width;
              	this.settings.height = height;
            }          
          
            if(src.length === 0) {                             
              	this.getBase64Image(image, this.settings.width, this.settings.height, this.settings.placeholderBg);
            }
		},
      	getPerc: function (num, percent) {
            percent = Number(num) - ((Number(percent) / 100) * Number(num));
          	return num - percent;
        },
        getBase64Image: function(image, width, height, bg, watermark){
          	var _this = this;
			var canvas = document.createElement("CANVAS");
          	var context = canvas.getContext("2d");
          	var newImage;
          
          	canvas.width = width;
          	canvas.height = height;
          
          	context.fillStyle = bg;
          	context.fillRect(0, 0, width, height);
          
          	image.src = canvas.toDataURL("image/png");

            if(watermark && watermark.length) {
				newImage = new Image();              	
              	newImage.setAttribute('crossOrigin', 'anonymous');
              	newImage.src = watermark;
              
              	newImage.onload = function() {
                  var newImageW = newImage.width;
                  var newImageH = newImage.height;
                  var ratio = newImageH/newImageW;
                  var newW = _this.getPerc(width, _this.settings.watermarkPercent);
                  
                  newW = newW > newImageW ? newImageW : newW;
                  
                  var newH = Math.floor(newW * ratio);
                  var left = (width - newW)/2;
                  var top = (height - newH)/2;
                  
                  context.drawImage(newImage, left, top, newW, newH);
                  image.src = canvas.toDataURL("image/png");
                };
            
            }
        }
    };
  	

    root.lazyload = function(images, options) {
        return new LazyLoad(images, options);
    };

    if (root.jQuery) {
        var $ = root.jQuery;
        $.fn.lazyload = function (options) {
            options = options || {};
            options.attribute = options.attribute || "data-src";
            new LazyLoad($.makeArray(this), options);
            return this;
        };
    }

    return LazyLoad;
});



(function(win) {
  var cModal = function(options) {
      this.modal = document.createElement('div');
      this.classList = null;
      this.timeId = null;
      this.timer = null;
      this.openModal = true;

      this.int(options);
  };

  cModal.prototype.int = function(options) {
    var _this = this;

    _this.addClass(_this.modal, 'confirm-modal-backdrop');

    _this.createHtml(options);

    _this.modal.addEventListener('click', function(e) {
      if (_this.hasClass(e.target, 'btn-navigator')) {
        _this.btnClick(e.target);

      } else if (_this.hasClass(e.target, 'confirm-modal-loader')) {
        _this.hideModal();
      }
    });

    _this.modal.addEventListener('setMargin', function(e) {
      _this.setMargin();
    });

    _this.modal.addEventListener('show', function(e) {
      _this.showModal();
    });
  };

  cModal.prototype.createHtml = function(options) {
    var _this = this;

    _this.options = options;
    _this.timer = options.timer;
    _this.modal.innerHTML = '<div class="confirm-modal-loader"></div><div class="confirm-modal"><div class="confirm-modal-inner"></div></div>';
    _this.openModal = true;

    if (_this.options.id) {
      _this.modal.id = _this.options.id;
    }

    if(options.class) {
      _this.addClass(_this.modal, options.class);
    }

    var html = '';
    var buttons = '';
    var closeButton = _this.options.closeButton ? '<div data-callback="0" data-text="close" class="btn-navigator close-notification confirm-modal-close"></div>' : '';

    if (_this.options.buttonLabels && typeof _this.options.buttonLabels === 'object') {
      for (var ind = 0; ind < _this.options.buttonLabels.length; ind++) {
        var btnText = _this.options.buttonLabels[ind];
        var dataText = btnText;
        var closeClass = '';

        if (typeof btnText === 'string') {
          if (btnText.indexOf(':close') !== -1) {
            closeClass = 'close-notification';
            btnText = btnText.replace(':close', '');
            dataText = btnText;
          }

          if (btnText.indexOf(':timer') !== -1) {
            _this.timer = _this.timer ? _this.timer : 10;

            btnText = btnText.replace(':timer', ' <span class="notification-timer">(' + _this.timer + ')</span>');
            dataText = dataText.replace(':timer', '');
          }

          buttons += '<button data-callback="' + (ind + 1) + '" data-text="' + dataText + '" type="button" class="btn-navigator ' + closeClass + '">' + btnText + '</button>';
        }
      }
    }

    if (_this.timeId) {
      clearInterval(_this.timeId);
      _this.timeId = null;
    }

    html += (_this.options.title && _this.options.title.length) ? ('<div class="confirm-modal-header">' + _this.options.title + closeButton + '</div>') : closeButton;

    html += (_this.options.message && _this.options.message.length) ? ('<div class="confirm-modal-body">' + _this.options.message + '</div>') : ('<div class="confirm-modal-body"></div>');

    html += _this.options.buttonLabels ? ('<div class="confirm-modal-footer">' + buttons + '</div>') : '';

    _this.modal.getElementsByClassName('confirm-modal-inner')[0].innerHTML = html;


    _this.showModal();

  };

  cModal.prototype.showModal = function() {
    var _this = this;

    _this.openModal = true;

    if (!document.getElementById(_this.options.id)) {
      document.getElementsByTagName('body')[0].appendChild(_this.modal);
    }

    if (typeof _this.options.beforeShow === "function" && _this.options.beforeShow(_this.modal) === false) {
      _this.addClass(_this.modal, 'confirm-loader');

    } else {
      setTimeout(function() {
        _this.shown();
      }, 100);
    }
  };

  cModal.prototype.shown = function() {
    var _this = this;
    var _timerDiv = _this.modal.getElementsByClassName('notification-timer')[0];

    if(_this.openModal === false) {
      return false;
    }

    if (_this.options.onShow) {
      _this.options.onShow(_this.modal);
    }

    if (_timerDiv) {
      _this.timer = _this.options.timer ? _this.options.timer : 10;
      _timerDiv.textContent = '(' + _this.timer + ')';

      _this.timeId = setInterval(function() {

        if(!document.hidden) {
          _this.timer = (_this.timer - 1);

          var timerText = _this.timer === 0 ? '' : '(' + _this.timer + ')';

          _timerDiv.textContent = timerText;

          if (_this.timer === 0) {
            _this.hideModal();
            clearInterval(_this.timeId);
            _this.timeId = null;
          }

          if (_this.options.callback) {
            _this.options.callback(_this.timer, 'timer', _this.modal);
          }
        }
      }, 1000);
    }

    _this.addClass(_this.modal, 'show');
    _this.removeClass(_this.modal, 'confirm-loader');

    _this.addClass(document.getElementsByTagName('html')[0], 'c-modal-open');
  };

  cModal.prototype.hideModal = function(val, text) {
    var _this = this;

    val = typeof val === 'undefined' ? '0' : val;
    text = typeof text === 'undefined' ? 'close' : text;

    _this.openModal = false;

    //_this.modal.className = _this.classList;
    _this.removeClass(_this.modal, 'show');

    if (_this.timeId) {
      clearInterval(_this.timeId);
      _this.timeId = null;
    }

    setTimeout(function() {
      _this.modal.parentNode.removeChild(_this.modal);

      if (_this.options.onHide) {
        _this.options.onHide(val, text, _this.modal);
      }

      _this.removeClass(document.getElementsByTagName('html')[0], 'c-modal-open');

    }, 400);
  };

  cModal.prototype.btnClick = function(_ele) {
    var _this = this;
    var val = _ele.getAttribute('data-callback');
    var text = _ele.getAttribute('data-text');

    if (_this.hasClass(_ele, 'close-notification')) {
      _this.hideModal(text, val);
    }

    if (_this.options.callback) {
      _this.options.callback(val, text, _this.modal);
    }

  };

  cModal.prototype.hasClass = function(element, classname) {
    classname = classname.trim();

    var classes = element.className;
    var reg = new RegExp('(\\s|^)' + classname + '(\\s|$)');

    return reg.test(classes);
  };

  cModal.prototype.addClass = function(element, classname) {
    var cn = element.className;

    if (cn.indexOf(classname) !== -1) {
      return;
    }

    if (cn !== '') {
      classname = ' ' + classname;
    }

    element.className = cn + classname;
  };

    cModal.prototype.removeClass = function(element, classname) {
    classname = classname.split(' ');

    var classes = element.className;
    var newClasses = classes;

    for (var i = 0; i < classname.length; i++) {
      var reg = new RegExp('(\\s|^)' + classname[i]);

      if (classes.match(reg)) {
        newClasses = newClasses.replace(reg, '');
      }
    }

    if (newClasses !== classes) {
      element.className = newClasses.trim();
    }
  };

  win.cconfirm = function(options) {
    if (typeof options === 'object' && options) {
      if (options.id) {
        var data = win[options.id];

        if (data) {
          data.createHtml(options);
          return data;

        } else {
          win[options.id] = new cModal(options);
          return win[options.id];

        }

      } else {
        return new cModal(options);

      }
    }
  };
  
}(window));

(function ($) {
'use strict';

var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']

var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]

var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i

var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
}

/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
 */
var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi

/**
 * A pattern that matches safe data URLs. Only matches image, video and audio types.
 *
 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
 */
var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i

function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
        if ($.inArray(attrName, uriAttrs) !== -1) {
            return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
        }

        return true
    }

    var regExp = $(allowedAttributeList).filter(function(index, value) {
        return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
        if (attrName.match(regExp[i])) {
            return true
        }
    }

    return false
}

function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
        return unsafeHtml
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
        return sanitizeFn(unsafeHtml)
    }

    // IE 8 and below don't support createHTMLDocument
    if (!document.implementation || !document.implementation.createHTMLDocument) {
        return unsafeHtml
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization')
    createdDocument.body.innerHTML = unsafeHtml

    var whitelistKeys = $.map(whiteList, function(el, i) {
        return i
    })
    var elements = $(createdDocument.body).find('*')

    for (var i = 0, len = elements.length; i < len; i++) {
        var el = elements[i]
        var elName = el.nodeName.toLowerCase()

        if ($.inArray(elName, whitelistKeys) === -1) {
            el.parentNode.removeChild(el)

            continue
        }

        var attributeList = $.map(el.attributes, function(el) {
            return el
        })
        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])

        for (var j = 0, len2 = attributeList.length; j < len2; j++) {
            if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
                el.removeAttribute(attributeList[j].nodeName)
            }
        }
    }

    return createdDocument.body.innerHTML
}

// TOOLTIP PUBLIC CLASS DEFINITION
// ===============================

var Tooltip = function(element, options) {
    this.type = null
    this.options = null
    this.enabled = null
    this.timeout = null
    this.hoverState = null
    this.$element = null
    this.inState = null

    this.init('tooltip', element, options)
}

Tooltip.VERSION = '3.4.1'

Tooltip.TRANSITION_DURATION = 150

Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="c_tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
        selector: 'body',
        padding: 0
    },
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist
}

Tooltip.prototype.init = function(type, element, options) {
    this.enabled = true
    this.type = type
    this.$element = $(element)
    this.options = this.getOptions(options)
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState = {
        click: false,
        hover: false,
        focus: false
    }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
        throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
        var trigger = triggers[i]

        if (trigger == 'click') {
            this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
        } else if (trigger != 'manual') {
            var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin'
            var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

            this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
            this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
        }
    }

    this.options.selector ?
        (this._options = $.extend({}, this.options, {
            trigger: 'manual',
            selector: ''
        })) :
        this.fixTitle()
}

Tooltip.prototype.getDefaults = function() {
    return Tooltip.DEFAULTS
}

Tooltip.prototype.getOptions = function(options) {
    var dataAttributes = this.$element.data()

    for (var dataAttr in dataAttributes) {
        if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
            delete dataAttributes[dataAttr]
        }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options)

    if (options.delay && typeof options.delay == 'number') {
        options.delay = {
            show: options.delay,
            hide: options.delay
        }
    }

    if (options.sanitize) {
        options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
    }

    return options
}

Tooltip.prototype.getDelegateOptions = function() {
    var options = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function(key, value) {
        if (defaults[key] != value) options[key] = value
    })

    return options
}

Tooltip.prototype.enter = function(obj) {
    var self = obj instanceof this.constructor ?
        obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
        self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
        $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
        self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
        self.hoverState = 'in'
        return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function() {
        if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
}

Tooltip.prototype.isInStateTrue = function() {
    for (var key in this.inState) {
        if (this.inState[key]) return true
    }

    return false
}

Tooltip.prototype.leave = function(obj) {
    var self = obj instanceof this.constructor ?
        obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
        self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
        $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
        self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function() {
        if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
}

Tooltip.prototype.show = function() {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
        this.$element.trigger(e)

        var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
        if (e.isDefaultPrevented() || !inDom) return
        var that = this

        var $tip = this.tip()

        var tipId = this.getUID(this.type)

        this.setContent()
        $tip.attr('id', tipId)
        this.$element.attr('aria-describedby', tipId)

        if (this.options.animation) $tip.addClass('fade')

        var placement = typeof this.options.placement == 'function' ?
            this.options.placement.call(this, $tip[0], this.$element[0]) :
            this.options.placement

        var autoToken = /\s?auto?\s?/i
        var autoPlace = autoToken.test(placement)
        if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

        $tip
            .detach()
            .css({
                top: 0,
                left: 0,
                display: 'block'
            })
            .addClass(placement)
            .data('bs.' + this.type, this)

        this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
        this.$element.trigger('inserted.bs.' + this.type)

        var pos = this.getPosition()
        var actualWidth = $tip[0].offsetWidth
        var actualHeight = $tip[0].offsetHeight

        if (autoPlace) {
            var orgPlacement = placement
            var viewportDim = this.getPosition(this.$viewport)

            placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' :
                placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' :
                placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' :
                placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' :
                placement

            $tip
                .removeClass(orgPlacement)
                .addClass(placement)
        }

        var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

        this.applyPlacement(calculatedOffset, placement)

        var complete = function() {
            var prevHoverState = that.hoverState
            that.$element.trigger('shown.bs.' + that.type)
            that.hoverState = null

            if (prevHoverState == 'out') that.leave(that)
        }

        $.support.transition && this.$tip.hasClass('fade') ?
            $tip
            .one('bsTransitionEnd', complete)
            .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
            complete()
    }
}

Tooltip.prototype.applyPlacement = function(offset, placement) {
    var $tip = this.tip()
    var width = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop)) marginTop = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
        using: function(props) {
            $tip.css({
                top: Math.round(props.top),
                left: Math.round(props.left)
            })
        }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
        offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical = /top|bottom/.test(placement)
    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
}

Tooltip.prototype.replaceArrow = function(delta, dimension, isVertical) {
    this.arrow()
        .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
        .css(isVertical ? 'top' : 'left', '')
}

Tooltip.prototype.setContent = function() {
    var $tip = this.tip()
    var title = this.getTitle()

    if (this.options.html) {
        if (this.options.sanitize) {
            title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
        }

        $tip.find('.tooltip-inner').html(title)
    } else {
        $tip.find('.tooltip-inner').text(title)
    }

    $tip.removeClass('fade in top bottom left right')
}

Tooltip.prototype.hide = function(callback) {
    var that = this
    var $tip = $(this.$tip)
    var e = $.Event('hide.bs.' + this.type)

    function complete() {
        if (that.hoverState != 'in') $tip.detach()
        if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
            that.$element
                .removeAttr('aria-describedby')
                .trigger('hidden.bs.' + that.type)
        }
        callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
        $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()

    this.hoverState = null

    return this
}

Tooltip.prototype.fixTitle = function() {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
}

Tooltip.prototype.hasContent = function() {
    return this.getTitle()
}

Tooltip.prototype.getPosition = function($element) {
    $element = $element || this.$element

    var el = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect = el.getBoundingClientRect()
    if (elRect.width == null) {
        // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
        elRect = $.extend({}, elRect, {
            width: elRect.right - elRect.left,
            height: elRect.bottom - elRect.top
        })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset = isBody ? {
        top: 0,
        left: 0
    } : (isSvg ? null : $element.offset())
    var scroll = {
        scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop()
    }
    var outerDims = isBody ? {
        width: $(window).width(),
        height: $(window).height()
    } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
}

Tooltip.prototype.getCalculatedOffset = function(placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? {
            top: pos.top + pos.height,
            left: pos.left + pos.width / 2 - actualWidth / 2
        } :
        placement == 'top' ? {
            top: pos.top - actualHeight,
            left: pos.left + pos.width / 2 - actualWidth / 2
        } :
        placement == 'left' ? {
            top: pos.top + pos.height / 2 - actualHeight / 2,
            left: pos.left - actualWidth
        } :
        /* placement == 'right' */
        {
            top: pos.top + pos.height / 2 - actualHeight / 2,
            left: pos.left + pos.width
        }

}

Tooltip.prototype.getViewportAdjustedDelta = function(placement, pos, actualWidth, actualHeight) {
    var delta = {
        top: 0,
        left: 0
    }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
        var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll
        var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
        if (topEdgeOffset < viewportDimensions.top) { // top overflow
            delta.top = viewportDimensions.top - topEdgeOffset
        } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
            delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
        }
    } else {
        var leftEdgeOffset = pos.left - viewportPadding
        var rightEdgeOffset = pos.left + viewportPadding + actualWidth
        if (leftEdgeOffset < viewportDimensions.left) { // left overflow
            delta.left = viewportDimensions.left - leftEdgeOffset
        } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
            delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
        }
    }

    return delta
}

Tooltip.prototype.getTitle = function() {
    var title
    var $e = this.$element
    var o = this.options

    title = $e.attr('data-original-title') ||
        (typeof o.title == 'function' ? o.title.call($e[0]) : o.title)

    return title
}

Tooltip.prototype.getUID = function(prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
}

Tooltip.prototype.tip = function() {
    if (!this.$tip) {
        this.$tip = $(this.options.template)
        if (this.$tip.length != 1) {
            throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
        }
    }
    return this.$tip
}

Tooltip.prototype.arrow = function() {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
}

Tooltip.prototype.enable = function() {
    this.enabled = true
}

Tooltip.prototype.disable = function() {
    this.enabled = false
}

Tooltip.prototype.toggleEnabled = function() {
    this.enabled = !this.enabled
}

Tooltip.prototype.toggle = function(e) {
    var self = this
    if (e) {
        self = $(e.currentTarget).data('bs.' + this.type)
        if (!self) {
            self = new this.constructor(e.currentTarget, this.getDelegateOptions())
            $(e.currentTarget).data('bs.' + this.type, self)
        }
    }

    if (e) {
        self.inState.click = !self.inState.click
        if (self.isInStateTrue()) self.enter(self)
        else self.leave(self)
    } else {
        self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
}

Tooltip.prototype.destroy = function() {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function() {
        that.$element.off('.' + that.type).removeData('bs.' + that.type)
        if (that.$tip) {
            that.$tip.detach()
        }
        that.$tip = null
        that.$arrow = null
        that.$viewport = null
        that.$element = null
    })
}

Tooltip.prototype.sanitizeHtml = function(unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
}

// TOOLTIP PLUGIN DEFINITION
// =========================

function Plugin(option) {
    return this.each(function() {
        var $this = $(this)
        var data = $this.data('bs.tooltip')
        var options = typeof option == 'object' && option

        if (!data && /destroy|hide/.test(option)) return
        if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
        if (typeof option == 'string') data[option]()
    })
}

var old = $.fn.tooltip

$.fn.tooltip = Plugin
$.fn.tooltip.Constructor = Tooltip


// TOOLTIP NO CONFLICT
// ===================

$.fn.tooltip.noConflict = function() {
    $.fn.tooltip = old
    return this
}
  
}(jQuery));

$(document).ready(function() {
  var watermark = $('.site-header__logo-link img').attr('src');
  
  $(".lazy-image").lazyload({
    src: 'data-src',
    watermark: watermark,
    afterLoad: function(img, src){
      //console.log(img);
    }
  });

  //product-swatches
  /*$(".product-swatches img").lazyload({
    src: 'data-src',
    src2: 'data-fsrc',
    watermark: watermark,
    width: 100,
    height: 40,
    afterLoad: function(img, src){
      //console.log(img);
    }
  });*/
  
  var ss = setInterval(function(){
    if(typeof Searchanise !== 'undefined') {
      if(Searchanise.$) {
        //console.log(Searchanise.$);
        clearInterval(ss);
        Searchanise.$.each(['appendTo'], function(key, fnName) {
            var fn = Searchanise.$.fn[fnName];

            Searchanise.$.fn[fnName] = function () {
                             
              return customAppend(fn, this, arguments);
                            
            };
        });
        
               

      }
    }
  }, 500);
  
  
  var customAppend = function(_fn, _this, _arguments){
       
  	if(_this.hasClass('snize-product')) {

        var _ele = _this;
        var _img = _ele.find('img');
        var _src = _img.attr('src');

        _img.removeAttr('src');
        _img.attr('data-src', _src);
		
      
      	$(_img[0]).lazyload({
            src: 'data-src',
            afterLoad: function(img, src){
              //console.log(img);
            }
        });
      
      return _fn.apply(_this, _arguments);
      
    } else {
      return _fn.apply(_this, _arguments);
    }
	
    
  };
  

      var divArchitectImgs = $('.divArchitectImgs');
      var dataStoreId = divArchitectImgs.attr('data-storeId');
      var dataHandle = divArchitectImgs.attr('data-handle');

      if(divArchitectImgs.length) {
        $.ajax({
          url: '/apps/dpg-hni/dpg/architect_images?storeId=' + dataStoreId + '&handle=' + dataHandle,
          type: "POST",
          dataType: 'json',
          crossDomain: true,
          success: function (data) {
            if(data.msgtype === 'success') {
              var files = data.files;
              var html = '';

              for(var n=0; n<files.length; n++) {
                var fileType = files[n].file_type ? files[n].file_type : files[n].file_url.substr(files[n].file_url.lastIndexOf('.') + 1);
                html += '<div class="divArchitectImgsCell"><div class="divArchitectImgsCellInner" data-url="' + files[n].file_url + '" data-fileType="' + fileType + '"><div class="divArchitectImgsCellImage"><span class="fileType">' + fileType + '</span><span class="downloadText">Download <i class="fa fa-download" aria-hidden="true"></i></span></div><div class="divArchitectImgsCellName">' + files[n].name + '</div></div></div>'
              }

              divArchitectImgs.html(html);
            }
          },
          error: function () {
          }
        });
      }

      $('html').on('click', '.divArchitectImgsCellInner', function(){
        var fileType = $(this).attr('data-fileType');
        trackDownloadeFiles(fileType,'architect-file-downloaded'); 
        
        var url = $(this).attr('data-url');
        window.open(url);
      });
      
      
        $('html').on('click', '.btn-2d-3d', function(){
          
          	var dataStoreId = $(this).attr('data-storeId');
          	var dataHandle = $(this).attr('data-handle');
            var dataProductId = $(this).attr('data-productId');
          
           // Track download architect files action                      
           trackDownloadeFiles(dataProductId,'architect-download-clicked'); 
          
          
            var popup = cconfirm({
                title: 'Download Architect Files (2D, 3D, Revit, etc.)',
                message: "",
                closeButton: true,
                timer: 20,
                id: 'popup',
              	class:'download-modal',
                buttonLabels: false,
                beforeShow: function(modal){
                    $.ajax({
                      url: '/apps/dpg-hni/dpg/architect_images?storeId=' + dataStoreId + '&handle=' + dataHandle,
                      type: "POST",
                      dataType: 'json',
                      crossDomain: true,
                      /*success: function (data) {                        
                        if(data.msgtype === 'success') {
                          var files = data.files;
                          var html = '';

                          for(var n=0; n<files.length; n++) {
                            var fileType = files[n].file_type ? files[n].file_type : files[n].file_url.substr(files[n].file_url.lastIndexOf('.') + 1);
                            html += '<div class="divArchitectImgsCell"><div class="divArchitectImgsCellInner" data-url="' + files[n].file_url + '" data-fileType="' + fileType + '"><div class="divArchitectImgsCellImage"><span class="fileType">' + fileType + '</span><span class="downloadText">Download <i class="fa fa-download" aria-hidden="true"></i></span></div><div class="divArchitectImgsCellName">' + files[n].name + '</div></div></div>'
                          }

                          console.log(popup);
                          modal.querySelector('.confirm-modal-body').innerHTML = html;
                          popup.shown();
                        } else {
                          modal.querySelector('.confirm-modal-body').innerHTML = data.msg;
                          popup.shown();
                        }
                      },*/
                      success: function (data) {                        
                        if(data.msgtype === 'success') {
                          const files = data.files;
                          console.log('files', files);
                          let html = `<div class="download-all-section">
                              <div>
                                  <strong>Download all files (${data.filesCount} files, ${data.fileSize})</strong>
                                  <div class="arcnote">Includes all 2D, 3D, Revit, and texture files</div>
                              </div>
                              <button class="download-all-btn" id="downloadAllBtn" data-handle="`+dataHandle+`">Download All</button>
                          </div>`;

                          Object.keys(files).forEach(categoryKey => {

                            const category = files[categoryKey];

                            if (!category.files || category.files.length === 0) {
                              return;
                            }

                            // Add category title
                            html += `<div class="file-type-group"><div class="group-header">
                                  <h3>${category.name}</h3>
                                  <button class="group-download-btn" data-handle="`+dataHandle+`" data-group="`+category.name+`" id="downloadGroupBtn">Download Group</button>
                                </div>`;
                            html += `<ul class="file-list">`;
                            category.files.forEach(file => {

                              const badge = file.badge 
                                ? `<span class="badge-2d">${file.badge}</span>` 
                                : '';

                              const fileType = file.file_type
                                ? file.file_type
                                : file.file_url.substring(file.file_url.lastIndexOf('.') + 1);

                              html += `
                                  <li class="file-item">
                                    <div class="file-info">
                                      <div class="file-icon">${file.ext}</div>
                                      <div class="file-details">
                                        <div class="file-name">
                                          ${file.name}
                                          ${badge}
                                        </div>
                                        <div class="file-meta">${file.size}</div>
                                      </div>
                                    </div>
                                    <a href="${file.file_url}" class="download-link" target="_blank" rel="noopener noreferrer" download="${file.name}" data-id="${file.id}">Download</a>
                                  </li>`;
                            });
                            html += `</ul"></div>`;

                          });

                          const body = modal.querySelector('.confirm-modal-body');

                          // Add class only if not exists
                          if (!body.classList.contains('confirm-modal-body-height')) {
                              body.classList.add('confirm-modal-body-height');
                          }

                          body.innerHTML = html;
                          popup.shown();
                        } else {
                          modal.querySelector('.confirm-modal-body').innerHTML = data.msg;
                          popup.shown();
                        }
                      },
                      error: function () {
                      }
                    });

                    return false;
                }
            });
          
          	
        });
  
  	$('html').on('click', '.btn-assembly', function(){
        var dataStoreId = $(this).attr('data-storeId');
        var dataHandle = $(this).attr('data-handle');

        var popup = cconfirm({
          title: 'Download Assembly Instruction Files',
          message: "",
          closeButton: true,
          timer: 20,
          id: 'popup',
          class:'download-modal',
          buttonLabels: false,
          beforeShow: function(modal){
            $.ajax({
              url: '/apps/dpg-hni/Symbols/assembly_files?storeId=' + dataStoreId + '&handle=' + dataHandle,
              type: "POST",
              dataType: 'json',
              crossDomain: true,
              success: function (data) {console.log(data);
                if(data.msgtype === 'success') {
                  var files = data.files;
                  var html = '';

                  for(var n=0; n<files.length; n++) {
                    var fileType = files[n].file_type ? files[n].file_type : files[n].file_url.substr(files[n].file_url.lastIndexOf('.') + 1);
                    html += '<div class="divArchitectImgsCell"><div class="divArchitectImgsCellInner" data-url="' + files[n].file_url + '"><div class="divArchitectImgsCellImage"><span class="fileType">' + fileType + '</span><span class="downloadText">Download <i class="fa fa-download" aria-hidden="true"></i></span></div><div class="divArchitectImgsCellName">' + files[n].name + '</div></div></div>'
                  }

                  console.log(popup);
                  modal.querySelector('.confirm-modal-body').innerHTML = html;
                  popup.shown();
                } else {
                  modal.querySelector('.confirm-modal-body').innerHTML = data.msg;
                  popup.shown();
                }
              },
              error: function () {
              }
            });

            return false;
          }
        });


      });
  
  	  $('html').on('click', '.btn-product-spec', function(){
        var dataStoreId = $(this).attr('data-storeId');
        var dataHandle = $(this).attr('data-handle');

        var popup = cconfirm({
          title: 'Download Product Specs Files',
          message: "",
          closeButton: true,
          timer: 20,
          id: 'popup',
          class:'download-modal',
          buttonLabels: false,
          beforeShow: function(modal){
            $.ajax({
              url: '/apps/dpg-hni/product-specs/product-specs-files?storeId=' + dataStoreId + '&handle=' + dataHandle,
              type: "POST",
              dataType: 'json',
              crossDomain: true,
              success: function (data) {
                if(data.msgtype === 'success') {
                  var files = data.files;
                  var html = '';

                  for(var n=0; n<files.length; n++) {
                    var fileType = files[n].file_type ? files[n].file_type : files[n].file_url.substr(files[n].file_url.lastIndexOf('.') + 1);
                    html += '<div class="divArchitectImgsCell"><div class="divArchitectImgsCellInner" data-url="' + files[n].file_url + '"><div class="divArchitectImgsCellImage"><span class="fileType">' + fileType + '</span><span class="downloadText">Download <i class="fa fa-download" aria-hidden="true"></i></span></div><div class="divArchitectImgsCellName">' + files[n].name + '</div></div></div>'
                  }

                  modal.querySelector('.confirm-modal-body').innerHTML = html;
                  popup.shown();
                } else {
                  modal.querySelector('.confirm-modal-body').innerHTML = data.msg;
                  popup.shown();
                }
              },
              error: function () {
              }
            });

            return false;
          }
        });


      });
  
});

document.addEventListener('click', function (e) {
    if ((e.target && e.target.id === 'downloadAllBtn') || (e.target && e.target.id === 'downloadGroupBtn')) {

        const button = e.target;
        const handle = e.target.getAttribute('data-handle');
        const group = e.target.getAttribute('data-group');

        if (button.disabled) return;
        // Save original text
        const originalText = button.innerText;
        // Disable + change text
        button.innerText = 'Processing...';
        button.disabled = true;

        // Add overlay
        const modalContainer = document.querySelector('.download-modal');
        //modalContainer.style.position = 'relative';

        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay';
        overlay.innerHTML = '<div class="modal-loader"></div>';
        modalContainer.appendChild(overlay);

        fetch('/apps/dpg-hni/dpg/download-architect-zip?storeId=999&handle=' + handle, {
            method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                  storeId: 999,
                  handle: handle,
                  group: group
              })
            })
            .then(res => res.json())
            .then(data => {

                if (data.status !== 'success') {
                    throw new Error('Zip generation failed');
                }

                // Normal browser download (NO truncation)
                window.open(data.file_url, '_blank');
                //window.location.href = data.file_url;
                // Restore button after redirect trigger
                button.innerText = originalText;
                button.disabled = false;
            })
            .catch(error => {
                console.error(error);
                alert('Download failed');
                // Restore on error
                button.innerText = originalText;
                button.disabled = false;
            })
            .finally(() => {
              // Remove overlay + restore button
              button.innerText = originalText;
              button.disabled = false;

              const existingOverlay = document.querySelector('.download-modal .modal-overlay');
              if (existingOverlay) existingOverlay.remove();
          });
    }
});

var validInput = function(ele) {
  var name = $(ele).attr('name');
  var emptyMessage = $(ele).attr('data-empty');
  var typeMessage = $(ele).attr('data-type');
  var lengthMessage = $(ele).attr('data-length');
  var NameMessage = 'Only alphabets are allowed in name';
  
  var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
  var testName = /^[ A-Za-z]*$/
  
  var returnVal = true;
  
  $('[data-for="' + name + '"]').remove();
  
  if(ele.value) {
    $(ele).removeClass('input-error');
    
    if($(ele).attr('type') === 'email' && testEmail.test(ele.value) === false) {
      	$(ele).addClass('input-error');
    	$('<p class="error-text" data-for="' + name + '">' + typeMessage + '</p>').insertAfter(ele);
      
      	returnVal = false;
    }
    
    if($(ele).attr('type') === 'password' && 5 > ele.value.length) {
      	$(ele).addClass('input-error');
    	$('<p class="error-text" data-for="' + name + '">' + typeMessage + '</p>').insertAfter(ele);
      
      	returnVal = false;
    }
    
    if($(ele).attr('id') === 'FirstName') {      
      if(2 > ele.value.length) {
      	$(ele).addClass('input-error');
    	$('<p class="error-text" data-for="' + name + '">' + lengthMessage + '</p>').insertAfter(ele);
        returnVal = false;
      } else if (testName.test(ele.value) === false){
        $(ele).addClass('input-error');
    	$('<p class="error-text" data-for="' + name + '">' + NameMessage + '</p>').insertAfter(ele);
        returnVal = false;
      }
    }
    
    if($(ele).attr('id') === 'LastName') {      
      if(2 > ele.value.length) {
      	$(ele).addClass('input-error');
    	$('<p class="error-text" data-for="' + name + '">' + lengthMessage + '</p>').insertAfter(ele);
        returnVal = false;
      } else if (testName.test(ele.value) === false){
        $(ele).addClass('input-error');
    	$('<p class="error-text" data-for="' + name + '">' + NameMessage + '</p>').insertAfter(ele);
        returnVal = false;
      }
      	
    }
    
  } else {
    $(ele).addClass('input-error');
    $('<p class="error-text" data-for="' + name + '">' + emptyMessage + '</p>').insertAfter(ele);
    returnVal = false;
  }
  
  return returnVal;
  
};

var validFrom = function() {
	var inputs = document.querySelectorAll('.required-input');
  	var returnVal = true;
  
    inputs.forEach(function(ele){
      if(validInput(ele) === false) {
        returnVal = false;
      }
    });
  
    return returnVal;
  
  //console.log(inputs);
};

$(document).ready(function(){
	$('html').on('change', '#productSelect-option-0', function(){
    	var _val = this.value;
      	var _img = $('img[alt="' + _val + '"]:visible');
      	var _src = _img.attr('src');
      
      	$('.fabric img').attr('src', _src);
    	$('.fabSwatch').attr('value', _src);
      	//$('.fabric span').html(_val);
    });
  
    $('#create_customer').on('submit', function(){
      if(validFrom() === false) {
        return false;
      }
    });
  
  $('#create_customer').attr('novalidate', '');
  
  $('.edit-input-btn').click(function(){
  	$(this).closest('.edit-div').addClass('edit-div-open');
    
    return false;
  });
  
  $('.edit-input-cancel').click(function(){
  	$(this).closest('.edit-div').removeClass('edit-div-open');
    
    return false;
  });
  
  $('.edit-input-save').click(function() {
    var id = parseInt($(this).attr('data-id'));
    var editDiv = $(this).closest('.edit-div');
    var input = editDiv.find('.edit-input input');
    var val = input.val();
    var dataVal = input.attr('data-val');
    var dataProperty = $(this).attr('data-property');
    var quantity = parseInt($(this).attr('data-quantity'));
    var line, properties;
    
    var getItem = function(_items, _id, _dataVal, _property) {
      var _line, _item;
      _items.forEach(function(obj, ind) {
        if(obj.id === _id && _dataVal === obj.properties[_property]) {
          _line = ind + 1;
          _item = obj;
        }
      });
      
      if(_item) {
        return {
          line: _line,
          item: _item
        }
      } else {
        return false;
      }
    };
    
    if(val !== dataVal) {
      input.attr('readonly', true);
      
      $.getJSON('/cart.js', function(cart) {
        var findData = getItem(cart.items, id, dataVal, dataProperty);

        if(findData) {
          properties = findData.item.properties;
          properties[dataProperty] = val;
          line = findData.line;
          
          $.ajax({
            url: '/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: {
              quantity: findData.item.quantity,
              line: line,
              properties: properties
            },
            success: function(newcart) {
              findData = getItem(newcart.items, id, val, dataProperty);
              
              if(findData.item.quantity !== quantity) {
                window.location.reload();
              }
              
              editDiv.removeClass('edit-div-open');
              editDiv.find('.edit-text span').text(val);
              input.attr('data-val', val).attr('readonly', false);
            }
          });
        } else {
          window.location.reload();
        }
      });
    } else {
      editDiv.removeClass('edit-div-open');
    }
    
    return false;
  });

});

$('html').on('click', '.pagination a', function(){
	$("html, body").animate({ scrollTop: 0 }, 600);
});


if(typeof searchCustomerId != "undefined" && searchCustomerId != '') {
    /* UPDATE QUOTE START */
    $('#tierValue').on('click', function () {
      var customerTier = $('.clsStaffTier').attr("data-tier");

      $(".clsStaffTier").attr('style', 'border: 0px !important;background-color: white!important;');
      
      if(customerTier == 'allsteel') {
        $('.clsStaffTier').html('<div><select id="newTier" onchange="updateTierLevel();" style="background-color:#e9e9e9;"><option value="allsteel" selected>Allsteel</option><option value="tier-1">Tier 1</option><option value="tier-2">Tier 2</option><option value="tier-3">Tier 3</option><option value="platform-pro">Spec & Design</option><option value="tradeprogram">Trade Program</option></select></div>');
      } else if(customerTier == 'tier-1') {
        $('.clsStaffTier').html('<div><select id="newTier" onchange="updateTierLevel();" style="background-color:#e9e9e9;"><option value="allsteel">Allsteel</option><option value="tier-1" selected>Tier 1</option><option value="tier-2">Tier 2</option><option value="tier-3">Tier 3</option><option value="platform-pro">Spec & Design</option><option value="tradeprogram">Trade Program</option></select></div>');
      } else if(customerTier == 'tier-2') {
        $('.clsStaffTier').html('<div><select id="newTier" onchange="updateTierLevel();" style="background-color:#e9e9e9;"><option value="allsteel">Allsteel</option><option value="tier-1">Tier 1</option><option value="tier-2" selected>Tier 2</option><option value="tier-3">Tier 3</option><option value="platform-pro">Spec & Design</option><option value="tradeprogram">Trade Program</option></select></div>');
      } else if(customerTier == 'tier-3') {
        $('.clsStaffTier').html('<div><select id="newTier" onchange="updateTierLevel();" style="background-color:#e9e9e9;"><option value="allsteel">Allsteel</option><option value="tier-1">Tier 1</option><option value="tier-2">Tier 2</option><option value="tier-3" selected>Tier 3</option><option value="platform-pro">Spec & Design</option><option value="tradeprogram">Trade Program</option></select></div>');
      } else if(customerTier == 'platform-pro') {
        $('.clsStaffTier').html('<div><select id="newTier" onchange="updateTierLevel();" style="background-color:#e9e9e9;"><option value="allsteel">Allsteel</option><option value="tier-1">Tier 1</option><option value="tier-2">Tier 2</option><option value="tier-3">Tier 3</option><option value="platform-pro" selected>Spec & Design</option><option value="tradeprogram">Trade Program</option></select></div>');
      } else if(customerTier == 'tradeprogram') {
        $('.clsStaffTier').html('<div><select id="newTier" onchange="updateTierLevel();" style="background-color:#e9e9e9;"><option value="allsteel">Allsteel</option><option value="tier-1">Tier 1</option><option value="tier-2">Tier 2</option><option value="tier-3">Tier 3</option><option value="platform-pro">Spec & Design</option><option value="tradeprogram" selected>Trade Program</option></select></div>');
      }
  	});


   function updateTierLevel() {
     var existingTier = $('.clsStaffTier').attr("data-tier");
     
     var result = confirm('Click OK to proceed');
     if(!result) {
       $('#newTier').val($('.clsStaffTier').attr("data-tier"));
       return false;
     }
     
     var newTierValue = $('#newTier').val(); 

     if(existingTier != newTierValue) {
      $('#page-loader').show();
        $.ajax({
            type: 'POST',
            url: '/apps/dpg-hni/dpg/change-tier/999',
            dataType: 'json',
            cache: false,
            data: {customerId:searchCustomerId, newTierValue:newTierValue},
            success: function (response) {              
              if(response.response == 'success') {
                //setTimeout(() => location.reload(), 10000);
                  //location.reload();
                  setTimeout(function () {
                    window.location.reload();
                    /*  const url = new URL(window.location.href);
                      url.searchParams.set('_refresh', Date.now());

                      window.location.href = url.toString();
                      //window.location.href = '/account/logout';*/

                  }, 5000);
              }
            }
          });
     }     
   }
   }





